import { render } from "./NewsArticleView.vue?vue&type=template&id=79e81d7a"
import script from "./NewsArticleView.vue?vue&type=script&lang=js"
export * from "./NewsArticleView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__